// import { Route } from "react-router-dom";
// import AssignInfoToMap from "../../../pages/Views/LandInfraDevelopment/GISView/Forms/AssignInfoToMap/AssignInfoToMap";
// import ExportDataPage from "../../../pages/Views/LandInfraDevelopment/GISView/MapRelated/ExportDataPage";
// import PrintMap from "../../../pages/Views/LandInfraDevelopment/GISView/PrintMapFinal/PrintMap";
// //prettier-ignore
// import { ViewMap, ViewInfrastructureMap, EditMap, ViewMapByCategoryPage, ViewPlanningMap, ViewUnapprovedMap, ViewCadastreMap } from "../../../pages/Views/LandInfraDevelopment/GISView/MapRelated/Views";
// import GISReports from "../../../pages/Views/LandInfraDevelopment/GISView/Reports/GISReports";
// import GISDashboard from "../../../pages/Views/LandInfraDevelopment/GISView/GISDashboard";
// import ImportExistingParkData from "../../../pages/Views/LandInfraDevelopment/GISView/Forms/ImportSpatialData/ImportExistingParkData";
// //import MapDataProvider from "../../../pages/Views/LandInfraDevelopment/GISView/MapRelated/MapData/MapDataProvider";
// import EditImportedData from "../../../pages/Views/LandInfraDevelopment/GISView/Forms/ImportSpatialData/EditImportedData";
// //import Map from "../../../pages/Views/LandInfraDevelopment/GISView/MapRelated/Map";
// export default function GISRoutes() {
//   return (
//     <>
//       <Route path="/" element={<GISDashboard />} />
//       <Route path="/viewMap" element={<ViewMap />} />
//       <Route path="/viewMapByCategory" element={<ViewMapByCategoryPage />} />

//       <Route path="/importSpatial" element={<ImportExistingParkData />} />
//       <Route path="/assignInfo" element={<AssignInfoToMap />} />
//       <Route path="/editMap" element={<EditMap />} />
//       <Route path="/printMap" element={<PrintMap />} />
//       <Route path="/exportMap" element={<ExportDataPage />} />
//       <Route path="/infrastructureMap" element={<ViewInfrastructureMap />} />
//       <Route path="/viewPlanningMap" element={<ViewPlanningMap />} />
//       <Route path="/viewCadastreMap" element={<ViewCadastreMap />} />
//       <Route path="/editImportedData" element={<EditImportedData />} />
//       <Route path="/gisReports" element={<GISReports />} />
//       <Route path="/viewUnapprovedMap" element={<ViewUnapprovedMap />} />
//     </>
//   );
// }

//////////////////////////////////
import { Route } from "react-router-dom";

import AssignInfoToMap from "../../../pages/Views/LandInfraDevelopment/GISView/Forms/AssignInfoToMap/AssignInfoToMap";
import ExportDataPage from "../../../pages/Views/LandInfraDevelopment/GISView/MapRelated/ExportDataPage";
//import PrintMap from "../../../pages/Views/LandInfraDevelopment/GISView/PrintMapFinal/PrintMap";
import PrintMap from "../../../pages/Views/LandInfraDevelopment/GISView/MapRelated/PrintMap/PrintMap";
//prettier-ignore
import MapDataProvider from "../../../pages/Views/LandInfraDevelopment/GISView/MapRelated/MapData/MapDataProvider";
import { ViewMap, ViewInfrastructureMap, EditMap, ViewMapByCategoryPage, ViewPlanningMap, ViewUnapprovedMap, ViewCadastreMap } from "../../../pages/Views/LandInfraDevelopment/GISView/MapRelated/Views";
import GISReports from "../../../pages/Views/LandInfraDevelopment/GISView/Reports/GISReports";
import RetioReport from "../../../pages/Views/LandInfraDevelopment/GISView/Reports/RatioReport";
import ParkLandUsePieChart from "../../../pages/Views/LandInfraDevelopment/GISView/ParkLandUsePieChart";
import GISDashboard from "../../../pages/Views/LandInfraDevelopment/GISView/GISDashboard";
import PreparePlanToIssueToInvestor from "../../../pages/Views/LandInfraDevelopment/MasterPlanandLandBankView/Forms/PreparePlanToIssueToInvestor";
import ImportExistingParkData from "../../../pages/Views/LandInfraDevelopment/GISView/Forms/ImportSpatialData/ImportExistingParkData";
//import MapDataProvider from "../../../pages/Views/LandInfraDevelopment/GISView/MapRelated/MapData/MapDataProvider";
import EditImportedData from "../../../pages/Views/LandInfraDevelopment/GISView/Forms/ImportSpatialData/EditImportedData";
//import Map from "../../../pages/Views/LandInfraDevelopment/GISView/MapRelated/Map";
import ViewApproveDecline from "../../../pages/Views/LandInfraDevelopment/GISView/MapRelated/Views/ViewApproveDecline"
export default function GISRoutes() {
  return (
    <>
      <Route path="/" element={<GISDashboard />} />
      <Route path="/viewMap" element={<ViewMap />} />
      <Route path="/viewMapByCategory" element={<ViewMapByCategoryPage />} />
      <Route path="/printPlanForOpearation" element={<PreparePlanToIssueToInvestor />} />
      <Route path="/approvedecline" element={<ViewApproveDecline />} />
      <Route path="/importSpatial" element={<ImportExistingParkData />} />
      <Route path="/assignInfo" element={<AssignInfoToMap />} />
      <Route path="/editMap" element={<EditMap />} />
      <Route path="/printMap" element={<MapDataProvider> <PrintMap /> </MapDataProvider>} />
      <Route path="/exportMap" element={<MapDataProvider><ExportDataPage /> </MapDataProvider>} />
      <Route path="/infrastructureMap" element={<ViewInfrastructureMap />} />
      <Route path="/viewPlanningMap" element={<ViewPlanningMap />} />
      <Route path="/viewCadastreMap" element={<ViewCadastreMap />} />
      <Route path="/editImportedData" element={<EditImportedData />} />
      <Route path="/ratioreport" element={<RetioReport />} />
      <Route path="/gisReports" element={<GISReports />} />
      <Route path="/" element={<GISReports />} />
      <Route path="/viewUnapprovedMap" element={<ViewUnapprovedMap />} />
      <Route path="/landparkuse" element={<ParkLandUsePieChart />} />
     
    </>
  );
}
///////////////////////////////////
